<template>
  <v-app>
    <!-- Conteúdo principal -->
    <v-main>
      <slot />
    </v-main>
    <Footer/>
  </v-app>
</template>

<script setup>
import { ref, computed } from 'vue'
import Footer from '@/components/Footer.vue'

const mobileMenu = ref(false)

const currentYear = computed(() => new Date().getFullYear())
</script>